// 全部保单接口
import request from '../request';
import qs from 'qs';

// 历史保险卡
const queryHisCard =  (data) => {
  	return request.post(`/api/wx/auth/queryHisCard?${qs.stringify(data)}`, data)
}
// 有效保单
const queryEffectivePolicy = (data) => {
  	return request.post(`/api/wx/auth/queryEffectivePolicy?${qs.stringify(data)}`, data)
}
// 历史保单
const queryHisPolicy = (data) => {
  	return request.post(`/api/wx/auth/queryHisPolicy?${qs.stringify(data)}`, data)
}
// 对象数组
export default {
	queryHisCard,
	queryEffectivePolicy,
	queryHisPolicy
};


